export default __webpack_public_path__ + "static/media/titleF2P.dd107db2.svg";